import styled, { keyframes } from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';

export const LoadingStrip = ({ className }: { className?: string }) => (
  <Outer className={className} data-testid="loading-indicator">
    <Inner />
  </Outer>
);

export const slide = keyframes`
  0% {
    left: -100px;
    opacity: 1;
  }

  25% {
    opacity: 1;
  }

  100% {
    left: 360px;
    opacity: 0;
  }
`;

export const Outer = styled.div`
  background-color: ${ThemeColours.mono100};
  border-radius: 4px;
  min-height: 12px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const Inner = styled.div`
  animation: ${slide} 1.5s;
  animation-iteration-count: infinite;
  background: linear-gradient(
    to right,
    ${ThemeColours.mono100},
    ${ThemeColours.white},
    ${ThemeColours.mono100}
  );
  height: 100%;
  position: absolute;
  width: 100px;
`;
